fxType